export const buildInstallationNodePath = (basePath, nodeId) => {
  if (nodeId == null || nodeId === '') {
    return basePath || null
  }
  if (!basePath) {
    return `/${nodeId}`
  }
  return `${basePath}/${nodeId}`
}

export const getRootTreeIdFromPath = (path, fallback = null) => {
  if (!path || typeof path !== 'string') {
    return fallback
  }
  const segments = path.split('/').filter(Boolean)
  return segments[1] ?? segments[0] ?? fallback
}

/**
 * Resolves a tree node when API ids and hyper-tree node ids differ in type (number vs string).
 */
export const getInstallationTreeNode = (tree, id) => {
  if (id == null || id === '' || !tree?.instance?.getNodeById) {
    return null
  }

  const candidates = [id, Number(id), String(id)].filter((value, index, arr) => {
    if (arr.indexOf(value) !== index) {
      return false
    }
    if (typeof value === 'number') {
      return !Number.isNaN(value)
    }
    return true
  })

  return candidates.reduce(
    (found, candidate) => found || tree.instance.getNodeById(candidate),
    null,
  )
}
